
import React, { Component } from 'react';
import { func } from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';

import styles from './styles';

import ListItem from './ListItem';
import ListItemPlus from './ListItemPlus';

import Translatable from '../../../../../../components/Translatable';

export default class GuestPanel extends Component {
    static propTypes = {
        onClick: func.isRequired
    }

    constructor(props) {
        super(props);
        this._options = [];
        this._options.push(
            <li
                key={shortid.generate()}
                className={css(styles.dropdownItem)}
                data-value=""
                onClick={this.props.onClick}
            >
                <div className={css(styles.textContainer)}>
                    <div className={css(styles.filtersText)}>
                        <Translatable
                            content={{
                                transKey: 'common.any'
                            }}
                        />
                    </div>
                </div>
            </li>
        );
        for (let i = 1; i <= 1000; i++) {
            if (i === 1 || i < 100) {
                this._options.push(
                    <ListItem
                        key={shortid.generate()}
                        i={i}
                        onClick={this.props.onClick}
                    >
                        <div className={css(styles.textContainer)}>
                            <div className={css(styles.filtersText)}>
                                <Translatable
                                    content={{
                                        transKey: 'common.people_count',
                                        count: i,
                                        replacements: {
                                            number: i
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </ListItem>
                );
            } else if (i % 10 === 0 && i <= 250) {
                this._options.push(
                    <ListItemPlus
                        key={shortid.generate()}
                        i={i}
                        onClick={this.props.onClick}
                    >
                        <div className={css(styles.textContainer)}>
                            <div className={css(styles.filtersText)}>
                                <Translatable
                                    content={{
                                        transKey: 'common.people_count',
                                        count: i,
                                        replacements: {
                                            number: i
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </ListItemPlus>
                );
            } else if (i % 100 === 0 && i < 1000) {
                this._options.push(
                    <ListItemPlus
                        key={shortid.generate()}
                        i={i}
                        onClick={this.props.onClick}
                    >
                        <div className={css(styles.textContainer)}>
                            <div className={css(styles.filtersText)}>
                                <Translatable
                                    content={{
                                        transKey: 'common.people_count',
                                        count: i,
                                        replacements: {
                                            number: i
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </ListItemPlus>
                );
            }
        }
        this._options.push(
            <ListItemPlus
                key={shortid.generate()}
                i={1000}
                onClick={this.props.onClick}
            >
                <div className={css(styles.textContainer)}>
                    <div className={css(styles.filtersText)}>
                        <Translatable
                            content={{
                                transKey: 'common.people_count',
                                count: 200,
                                replacements: {
                                    number: 200
                                }
                            }}
                        />
                    </div>
                </div>
            </ListItemPlus>
        );
    }

    render() {
        return (
            <div
                role="panel"
                className={css(styles.panel)}
            >
                <div
                    id="guest_panel"
                    role="menu"
                    className={css(styles.dropdown)}
                >
                    <ul
                        className={css(styles.panelList)}
                        role="listbox"
                    >
                        {this._options}
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/GuestInput/GuestPanel/GuestPanel.jsx